import { forwardRef } from 'react';

import { Button } from '../..';
import { TProps } from './types/TProps';

export const SwitchButton = forwardRef<HTMLButtonElement, TProps>(
  ({ active, className, type = 'button', ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      className={['btn--switch', active ? 'btn--switch-active' : 'btn--switch-inactive', className]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  ),
);

SwitchButton.displayName = 'SwitchButton';
